module.exports = __webpack_public_path__ + "static/img/slide_1.7534ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/slider/slide_1.png
// module id = 95aS
// module chunks = 0